module.exports = __webpack_public_path__ + "static/media/3.d56a7f2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/world-allergy-day-2017/3.jpg
// module id = 661
// module chunks = 0